var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17185 17.4948H8.00352C5.01602 17.4948 3.52268 17.4948 2.59435 16.549C1.66602 15.6031 1.66602 14.0806 1.66602 11.0365C1.66602 7.99229 1.66602 6.46979 2.59435 5.52396C3.52268 4.57813 5.01602 4.57812 8.00352 4.57812H11.1727C14.1602 4.57812 15.6543 4.57813 16.5827 5.52396C17.2968 6.25146 17.461 7.32063 17.4993 9.16146",
    stroke: "#495057",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 15.7057L14.582 14.9557V13.0807M13.332 4.58073L13.2487 4.3224C12.837 3.03906 12.6304 2.3974 12.1395 2.03073C11.6479 1.66406 10.9962 1.66406 9.69203 1.66406H9.47203C8.16786 1.66406 7.51536 1.66406 7.02453 2.03073C6.53286 2.3974 6.32703 3.03906 5.91453 4.3224L5.83203 4.58073M10.832 14.5807C10.832 15.0732 10.929 15.5608 11.1175 16.0158C11.3059 16.4708 11.5822 16.8842 11.9304 17.2324C12.2786 17.5806 12.692 17.8568 13.147 18.0453C13.6019 18.2337 14.0896 18.3307 14.582 18.3307C15.0745 18.3307 15.5621 18.2337 16.0171 18.0453C16.4721 17.8568 16.8855 17.5806 17.2337 17.2324C17.5819 16.8842 17.8581 16.4708 18.0466 16.0158C18.235 15.5608 18.332 15.0732 18.332 14.5807C18.332 13.5862 17.9369 12.6323 17.2337 11.9291C16.5304 11.2258 15.5766 10.8307 14.582 10.8307C13.5875 10.8307 12.6336 11.2258 11.9304 11.9291C11.2271 12.6323 10.832 13.5862 10.832 14.5807Z",
    stroke: "#495057",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkActivity);
export default __webpack_public_path__ + "static/media/work-activity.34522ed7978ca1a6500cd13f97019388.svg";
export { ForwardRef as ReactComponent };